// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__sdK4C","icon":"SortAdornment_icon__3dpHN","up":"SortAdornment_up__22D9M","down":"SortAdornment_down__2Ud7w","active":"SortAdornment_active__rCg4S"};